module.exports = __webpack_public_path__ + "img/SVG9_EstimateCost.cb6d3d53.svg";